import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { ListOnCall as UsecaseListOnCall } from '~/domain/usecases/duty/remote';
import { RemoteListOnCall } from '~/data/repository/duty';

/**
 * send request via API.
 */
export const makeRemoteListOnCall = (): UsecaseListOnCall =>
  new RemoteListOnCall(makeApiUrl('/oncall'), makeHttpClient());
